import React from 'react'

const SvgContract = props => (
    <svg width="1em" height="1em" viewBox="0 0 11 13" {...props}>
        <path d="M7.125 0H1.708C.811 0 .083.728.083 1.625v9.75C.083 12.272.811 13 1.708 13h7.567a1.64 1.64 0 001.642-1.625V3.792L7.125 0zm0 1.514l2.263 2.278H7.125V1.514zm2.15 10.403H1.708a.542.542 0 01-.541-.542v-9.75c0-.299.243-.542.541-.542h4.334v3.792H9.833v6.5a.558.558 0 01-.558.542z" />
    </svg>
)

export default SvgContract
